import { TemplateRef } from '@angular/core';

export interface Prop {
  id: number | string;
  name: string;
  disabled?: boolean;
}

export interface LogStepCriteriaProp extends Prop {
  afterTpl?: TemplateRef<any> | string;
  templateName?: string;
}

export interface PropsMap {
  [key: string]: Prop;
}

export interface DisplayMap {
  [key: number]: string;
}

export function propsMapToDisplayMap(propsMap: PropsMap): DisplayMap {
  return Object.values(propsMap).reduce((acc, cur) => ({ ...acc, [cur.id]: cur.name }), {});
}

export function propsMapToArray(propsMap: PropsMap): ReadonlyArray<Prop> {
  return Object.values(propsMap);
}
